import { render, staticRenderFns } from "./numbers-badge-state.vue?vue&type=template&id=8dc2eb7a&"
import script from "./numbers-badge-state.vue?vue&type=script&lang=js&"
export * from "./numbers-badge-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports